import Rest from '../Rest'

export interface StripeConnectStatus {
  gateway: string
  connected: boolean
  charges_enabled: boolean
  payouts_enabled: boolean
  requirements_due: {
    currently_due?: string[]
    past_due?: string[]
    disabled_reason?: string | null
  } | null
  external_account_id: string | null
  onboarded_at: string | null
}

export interface StripeConnectOnboarding {
  account_id: string
  url: string
  expires_at: number | null
}

/**
 * Conta do clube no Stripe Connect — destino do repasse no split.
 *
 * Sem uma conta com `charges_enabled`, a cobrança pelo Stripe segue sem split e o
 * valor inteiro fica na conta da plataforma.
 */
export default class StripeConnectService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/legal_entities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  /** Devolve a URL de onboarding (uso único, expira). */
  startOnboarding(legalEntityId: number): Promise<StripeConnectOnboarding> {
    return this.post(`/${legalEntityId}/stripe_connect/onboard`, {})
  }

  getStatus(legalEntityId: number): Promise<StripeConnectStatus> {
    return this.get(`/${legalEntityId}/stripe_connect/status`)
  }

  /** Link de login único para o dashboard Express do Stripe (expira em segundos, não cachear). */
  getLoginLink(legalEntityId: number): Promise<{ url: string }> {
    return this.get(`/${legalEntityId}/stripe_connect/login_link`)
  }
}
